import React from "react";
import { Button } from "@chakra-ui/react";

const NavLinks = () => {
  return (
    <>
      <Button variant="ghost">Home</Button>
      <Button variant="ghost">About</Button>

      <Button variant="ghost">Contact</Button>
    </>
  );
};

export default NavLinks;
